export enum AuthEventsKeys {
    AUTH_MANAGER_READY = 'AuthManagerReady', // 权限信息准备完成
    AUTH_CHANGE = 'onAuthChanged', // 文档的权限信息变化
    AUTH_EXP_TIME_CHANGE = 'onAuthExpTimeChanged', // 有效期更新
    AUTH_EXPIRED = 'onAuthExpired', // 有效期过期
    AUTH_PRIVILEGE_CHANGE = 'onAuthPrivilegeChange', // 用户在该文档的权限发生变化
    AUTH_MODIFIED = 'onAuthModified', // 其他终端修改文档的权限
}

export interface AuthEventsMap {
    [AuthEventsKeys.AUTH_MANAGER_READY]: void;
    [AuthEventsKeys.AUTH_CHANGE]: void;
    [AuthEventsKeys.AUTH_EXP_TIME_CHANGE]: boolean;
    [AuthEventsKeys.AUTH_EXPIRED]: void;
    [AuthEventsKeys.AUTH_PRIVILEGE_CHANGE]: { canEdit?: number, tipsMessage?: string };
    [AuthEventsKeys.AUTH_MODIFIED]: void;
}
